var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecipient2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20476 3.81082V3.81132V6.88728C8.20476 7.51882 8.01722 8.00087 7.69324 8.32484C7.36927 8.64882 6.88722 8.83636 6.25568 8.83636H3.18339C2.55185 8.83636 2.06986 8.64882 1.74591 8.32446C1.42193 8.00008 1.23431 7.51712 1.23431 6.88361V3.81132C1.23431 3.17977 1.42185 2.69773 1.74583 2.37376C2.0698 2.04978 2.55184 1.86224 3.18339 1.86224H6.25935C6.89093 1.86224 7.3729 2.0498 7.69637 2.37367C8.01981 2.69752 8.20649 3.17939 8.20476 3.81082ZM5.18019 6.81753V5.80812H6.1896C6.44146 5.80812 6.64843 5.60115 6.64843 5.3493C6.64843 5.09744 6.44146 4.89048 6.1896 4.89048H5.18019V3.88106C5.18019 3.62921 4.97322 3.42224 4.72137 3.42224C4.46951 3.42224 4.26255 3.62921 4.26255 3.88106V4.89048H3.25313C3.00128 4.89048 2.79431 5.09744 2.79431 5.3493C2.79431 5.60115 3.00128 5.80812 3.25313 5.80812H4.26255V6.81753C4.26255 7.06939 4.46951 7.27636 4.72137 7.27636C4.97322 7.27636 5.18019 7.06939 5.18019 6.81753Z",
    fill: "#92ABFE",
    stroke: "#92ABFE",
    strokeWidth: 0.367059
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipient2);
export default __webpack_public_path__ + "static/media/Recipient2.5707bed2bfaf0700489145086feecb40.svg";
export { ForwardRef as ReactComponent };